import { useCallback, useEffect, useState } from "react";
import { TLinkedVerificationRequest } from "../models";
import { getLinkedVerificationRequests } from "../network";

export const useLinkedVerificationRequests = (
  verificationRequestId?: string
): [TLinkedVerificationRequest[], boolean, () => Promise<void>] => {
  const [links, setLinks] = useState<TLinkedVerificationRequest[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const request = useCallback(async () => {
    if (!verificationRequestId) {
      setLinks([]);
      return;
    }

    setIsLoading(true);

    try {
      const response = await getLinkedVerificationRequests(verificationRequestId);
      setLinks(response);
    } catch {
      setLinks([]);
    }

    setIsLoading(false);
  }, [verificationRequestId]);

  useEffect(() => {
    request();
  }, [request]);

  return [links, isLoading, request];
};
